import { type Common } from './common.js';
import { type Log, type LogBase } from './models/log.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async create(log: LogBase): Promise<Log> {
    const url = this.common.constructPath('/log');
    return await this.common.postJSON(url, log);
  }
}
